import { useParams } from 'react-router-dom';

import { useOrg } from '@/contexts/OrgContext';
import { hasPermissionGroup } from '@/hooks/usePermissions';
import AuthLayout from '@/layouts/AuthLayout';
import { Button } from '@/lib/base/buttons/button';

export function BillingRequiredPage() {
  const { orgId: orgIdParam } = useParams<{ orgId: string }>();
  const { availableOrgs } = useOrg();

  const parsedOrgId = Number(orgIdParam);
  const team = !isNaN(parsedOrgId)
    ? availableOrgs.find(o => o.id === parsedOrgId)
    : undefined;
  const isAdmin = hasPermissionGroup(
    team?.permissionGroups,
    'ahoy_other_admin'
  );
  const billingHref = orgIdParam ? `/${orgIdParam}/settings/billing` : '#';

  return (
    <AuthLayout title='Subscription required'>
      <div className='flex flex-col gap-6' data-testid='billing-required-page'>
        <div className='flex flex-col gap-2'>
          <h1 className='text-2xl font-semibold text-[var(--color-text-primary)]'>
            Subscription required
          </h1>
          <p className='text-[var(--color-text-secondary)]'>
            {isAdmin
              ? 'This team needs an active subscription to continue. Set up billing to get started.'
              : 'This team needs an active subscription. Contact a team admin to set up billing.'}
          </p>
        </div>

        <div className='flex flex-col gap-3 sm:flex-row'>
          {isAdmin ? (
            <Button color='primary' href={billingHref}>
              Go to billing
            </Button>
          ) : (
            <>
              <Button color='primary' href='/account/logout'>
                Sign in to a different account
              </Button>
              <Button color='secondary' href='mailto:help@ahoy.ai'>
                Contact support
              </Button>
            </>
          )}
        </div>
      </div>
    </AuthLayout>
  );
}

export default BillingRequiredPage;
